import React, { Component } from 'react';
import irelandApi from '../../irelandApi';
import ArrowButton from '../common/button-arrow';
import { Link } from 'react-router-dom';
import ImageSlider from '../common/image-slider/image-slider';

class BrandCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brandData: [],
            loadingBrands: true
        };
    }

    componentDidMount() {
        irelandApi.get('/api/brands').then(res => {
            let array = [];
            res.data.data.map((item, key) => {
                    array.push({
                    inner: this.brandButton({ link: item.links.page, image: item.links.photo })
                });
                if (key == res.data.data.length - 1) {
                    this.setState({
                        brandData: array,
                        loadingBrands: false
                    })
                }
            })
        })
    }

    brandButton = props => {
        return (
        <div className="brand-item">
            <Link to={props.link} className="brand-link">
            <ArrowButton arrow={false} ghost={true} color='white' submit={false}>VIEW BRAND</ArrowButton>
            </Link>
            <img src={props.image} />
        </div>
        )
    }

    render() {
        if (this.state.loadingBrands) {
            return <div className="text-center"><h2>Loading...</h2></div>;
        }

        return (
            !!this.state.brandData.length && <ImageSlider
                data={this.state.brandData}
                title='OUR BRANDS'
                rows={1}
            />

        )
    }
}

export default BrandCarousel;


// WEBPACK FOOTER //
// ./src/components/home/brand-carousel.jsx